namespace GeniuzPOS.InitialData {
    export class PsDiscCouponTypeItemExtColumns {
        static columnsKey = 'InitialData.PsDiscCouponTypeItemExt';
    }
}
